import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  return <section className="w-full bg-gradient-to-br from-rose-500 via-pink-500 to-rose-400 py-20 sm:py-28" data-id="element-56">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-57">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-58">
          {/* Title */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-59">
            ¿Lista para Empezar tu Negocio de Imprimibles? 🎀
          </h2>

          {/* Slogan */}
          <p className="text-xl sm:text-2xl md:text-3xl font-extrabold mb-6" data-id="element-60">
            <span className="text-white" data-id="element-61">Diseñá hoy.</span>{' '}
            <span className="text-rose-200" data-id="element-62">Imprimí mañana.</span>{' '}
            <span className="text-amber-300" data-id="element-63">Ganá siempre.</span>
          </p>

          {/* Description */}
          <p className="text-xl text-rose-100 mb-4 max-w-2xl mx-auto" data-id="element-64">
            +25.000 diseños increíblemente hermosos y rentables te esperan. Una
            sola compra, ingresos de por vida.
          </p>

          {/* Price */}
          <div className="mb-8" data-id="element-65">
            <span className="text-rose-200 line-through text-lg" data-id="element-66">$89.990</span>{' '}
            <span className="text-4xl sm:text-5xl font-extrabold text-white" data-id="element-67">
              $27.990 ARS
            </span>
            <p className="text-rose-200 text-sm mt-1" data-id="element-68">
              pago único · acceso inmediato
            </p>
          </div>

          {/* CTA Button */}
          <motion.a href="https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778" target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-12 py-5 bg-white text-rose-600 text-xl font-bold rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} data-id="element-69">
            🛒 Obtener el Kit Completo Ahora — $27.990 ARS
          </motion.a>

          {/* Trust badges */}
          <motion.div className="mt-10 flex flex-wrap justify-center gap-4 text-sm text-rose-100" initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-70">
            <span data-id="element-71">✅ Descarga inmediata</span>
            <span className="hidden sm:inline" data-id="element-72">·</span>
            <span data-id="element-73">✅ Manual de uso incluido</span>
            <span className="hidden sm:inline" data-id="element-74">·</span>
            <span data-id="element-75">✅ Licencia comercial</span>
            <span className="hidden sm:inline" data-id="element-76">·</span>
            <span data-id="element-77">✅ Soporte incluido</span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}